// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-container {
    display: flex;
    flex-direction: row;
    /* Use row direction for larger screens */
    height: 100vh;
    background-color: #1a0d2d;
    padding: 0;
    margin: 0;
    color: white;
}

.contact-container .form-section {
    flex: 1 1;
    padding: 4rem 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 10px;
    margin-right: 0;
}

.contact-container .title {
    color: #FFF;
    font-size: 56px;
    font-weight: 700;
    line-height: 68px;
    text-align: left;
    margin-bottom: 16px;
    font-family: "Inter", sans-serif;
}

.contact-container .description {
    color: #FFF;
    font-size: 20px;
    font-weight: 400;
    line-height: 34px;
    margin-bottom: 27px;
}

.contact-container .form-section form {
    display: flex;
    flex-direction: column;
}

.contact-container .input-group {
    margin-bottom: 34px;
    background-color: #231b2e;
    padding: 0px 13px;
}

.contact-container .input-group label {
    display: block;
    color: #FFF;
    font-size: 12px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: -0.36px;
    opacity: 0.5;
    padding-top: 8px;
    margin-bottom: 0px;
}

.contact-container .input-group input,
.contact-container .input-group textarea {
    width: 100%;
    padding-bottom: 7px;
    border: none;
    background-color: transparent;
    border-radius: 5px;
    outline: none;
    color: #FFF;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.42px;
    opacity: 1;
}

.contact-container .input-group:focus-within {
    border: 1px solid #9256E8;
    background: rgba(146, 86, 232, 0.11);
}

.contact-container .input-group input::placeholder,
.contact-container .input-group textarea::placeholder {
    color: #ffffff;
}

.contact-container .submit-btn {
    background-color: #00ffa3;
    padding: 18px 100px;
    border: none;
    cursor: pointer;
    align-self: flex-end;
    color: #242424;
    text-align: center;
    font-size: 18.333px;
    font-style: normal;
    font-weight: 800;
    line-height: 13.333px;
}

.contact-container .submit-btn span {
    margin-left: 0.5rem;
}

.contact-container .image-section {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contact-container .image-section img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
}

/* Responsive Styles */
@media (max-width: 768px) {
    .contact-container {
        flex-direction: column;
        height: unset;
    }

    .contact-container .form-section {
        margin-right: 0;
        padding: 2rem 1rem;
    }

    .contact-container .title {
        font-size: 36px;
        line-height: 44px;
        text-align: center;
    }

    .contact-container .description {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
        text-align: center;
        padding-bottom: 20px;
    }

    .contact-container .input-group {
        margin-bottom: 24px;
        padding: 0 10px;
    }

    .contact-container .submit-btn {
        width: 100%;
        font-size: 1rem;
        padding: 0.8rem 2rem;
        align-self: center;
    }

    .contact-container .image-section img {
        width: 100%;
        height: auto;
    }
}

@media (max-width: 480px) {
    .contact-container .title {
        font-size: 28px;
        line-height: 36px;
    }

    .contact-container .description {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 12px;
    }

    .contact-container .input-group {
        margin-bottom: 20px;
        padding: 0 8px;
    }

    .contact-container .submit-btn {
        font-size: 0.9rem;
        padding: 0.6rem 1.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ContactForm/ContactForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;AACJ","sourcesContent":[".contact-container {\n    display: flex;\n    flex-direction: row;\n    /* Use row direction for larger screens */\n    height: 100vh;\n    background-color: #1a0d2d;\n    padding: 0;\n    margin: 0;\n    color: white;\n}\n\n.contact-container .form-section {\n    flex: 1;\n    padding: 4rem 3rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    border-radius: 10px;\n    margin-right: 0;\n}\n\n.contact-container .title {\n    color: #FFF;\n    font-size: 56px;\n    font-weight: 700;\n    line-height: 68px;\n    text-align: left;\n    margin-bottom: 16px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.contact-container .description {\n    color: #FFF;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 34px;\n    margin-bottom: 27px;\n}\n\n.contact-container .form-section form {\n    display: flex;\n    flex-direction: column;\n}\n\n.contact-container .input-group {\n    margin-bottom: 34px;\n    background-color: #231b2e;\n    padding: 0px 13px;\n}\n\n.contact-container .input-group label {\n    display: block;\n    color: #FFF;\n    font-size: 12px;\n    font-weight: 300;\n    line-height: 20px;\n    letter-spacing: -0.36px;\n    opacity: 0.5;\n    padding-top: 8px;\n    margin-bottom: 0px;\n}\n\n.contact-container .input-group input,\n.contact-container .input-group textarea {\n    width: 100%;\n    padding-bottom: 7px;\n    border: none;\n    background-color: transparent;\n    border-radius: 5px;\n    outline: none;\n    color: #FFF;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: -0.42px;\n    opacity: 1;\n}\n\n.contact-container .input-group:focus-within {\n    border: 1px solid #9256E8;\n    background: rgba(146, 86, 232, 0.11);\n}\n\n.contact-container .input-group input::placeholder,\n.contact-container .input-group textarea::placeholder {\n    color: #ffffff;\n}\n\n.contact-container .submit-btn {\n    background-color: #00ffa3;\n    padding: 18px 100px;\n    border: none;\n    cursor: pointer;\n    align-self: flex-end;\n    color: #242424;\n    text-align: center;\n    font-size: 18.333px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 13.333px;\n}\n\n.contact-container .submit-btn span {\n    margin-left: 0.5rem;\n}\n\n.contact-container .image-section {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.contact-container .image-section img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: cover;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n    .contact-container {\n        flex-direction: column;\n        height: unset;\n    }\n\n    .contact-container .form-section {\n        margin-right: 0;\n        padding: 2rem 1rem;\n    }\n\n    .contact-container .title {\n        font-size: 36px;\n        line-height: 44px;\n        text-align: center;\n    }\n\n    .contact-container .description {\n        font-size: 16px;\n        line-height: 24px;\n        margin-bottom: 16px;\n        text-align: center;\n        padding-bottom: 20px;\n    }\n\n    .contact-container .input-group {\n        margin-bottom: 24px;\n        padding: 0 10px;\n    }\n\n    .contact-container .submit-btn {\n        width: 100%;\n        font-size: 1rem;\n        padding: 0.8rem 2rem;\n        align-self: center;\n    }\n\n    .contact-container .image-section img {\n        width: 100%;\n        height: auto;\n    }\n}\n\n@media (max-width: 480px) {\n    .contact-container .title {\n        font-size: 28px;\n        line-height: 36px;\n    }\n\n    .contact-container .description {\n        font-size: 14px;\n        line-height: 20px;\n        margin-bottom: 12px;\n    }\n\n    .contact-container .input-group {\n        margin-bottom: 20px;\n        padding: 0 8px;\n    }\n\n    .contact-container .submit-btn {\n        font-size: 0.9rem;\n        padding: 0.6rem 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
